import { render, staticRenderFns } from "./ReviewerManagement.vue?vue&type=template&id=4c4aeaa7&scoped=true&"
import script from "./ReviewerManagement.vue?vue&type=script&lang=js&"
export * from "./ReviewerManagement.vue?vue&type=script&lang=js&"
import style0 from "./ReviewerManagement.vue?vue&type=style&index=0&id=4c4aeaa7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4aeaa7",
  null
  
)

export default component.exports